import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  Container,
  Typography,
  List,
  ListItem,
  ListItemText,
  IconButton,
  CircularProgress,
  Paper,
  Box,
  Button,
  Snackbar,
  Alert,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import backgroundImg from "../../../assets/ImgFundo/fundo-abstratoC.jpg";
import MediaUploadField from "../MediaUploadField";

const modules = {
  toolbar: [
    [{ font: [] }],
    [{ header: "1" }, { header: "2" }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ align: [] }],
    ["link", "image", "blockquote", "code-block"],
    ["clean"],
  ],
};

const GerenciarPodcasts = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  const [podcasts, setPodcasts] = useState([]);
  const [selectedPodcast, setSelectedPodcast] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [alertMessage, setAlertMessage] = useState({ type: "", text: "" });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPodcasts();
  }, []);

  const fetchPodcasts = async () => {
    try {
      const response = await axios.get(`${apiUrl}/podcasts`);
      setPodcasts(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Erro ao buscar podcasts:", error);
      setLoading(false);
    }
  };

  const handleEditClick = (podcast) => {
    setSelectedPodcast(podcast);
    setOpenDialog(true);
  };

  const handleDeletePodcast = async (id, titulo) => {
    const tituloLimpo = String(titulo || "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
    const confirmed = window.confirm(`Tem certeza que quer excluir o podcast "${tituloLimpo}"?`);
    if (!confirmed) return;

    const token = localStorage.getItem("token");
    if (!token) {
      setAlertMessage({ type: "error", text: "Você precisa estar autenticado para excluir um podcast." });
      setOpenSnackbar(true);
      return;
    }

    try {
      await axios.delete(`${apiUrl}/podcasts/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAlertMessage({ type: "success", text: "Podcast excluído com sucesso!" });
      fetchPodcasts();
    } catch (error) {
      setAlertMessage({ type: "error", text: "Erro ao excluir o podcast." });
    }
    setOpenSnackbar(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedPodcast((prev) => ({ ...prev, [name]: value }));
  };
  const setSelectedField = (name, value) => {
    setSelectedPodcast((prev) => ({ ...prev, [name]: value }));
  };
  const handleUploadError = (message) => {
    setAlertMessage({ type: "error", text: message });
    setOpenSnackbar(true);
  };
  const handleUploadSuccess = (message) => {
    setAlertMessage({ type: "success", text: message });
    setOpenSnackbar(true);
  };

  const handleQuillChange = (field, value) => {
    setSelectedPodcast((prev) => ({ ...prev, [field]: value }));
  };

  const handleSaveChanges = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setAlertMessage({ type: "error", text: "Você precisa estar autenticado para editar um podcast." });
      setOpenSnackbar(true);
      return;
    }

    try {
      await axios.put(`${apiUrl}/podcasts/${selectedPodcast._id}`, selectedPodcast, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAlertMessage({ type: "success", text: "Podcast atualizado com sucesso!" });
      fetchPodcasts();
      setOpenDialog(false);
    } catch (error) {
      setAlertMessage({ type: "error", text: "Erro ao atualizar o podcast." });
    }
    setOpenSnackbar(true);
  };

  return (
    <div
    style={{
        padding: '20px',
        backgroundImage: `url(${backgroundImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '100vh',
        color: 'white', // Para garantir que o texto tenha boa visibilidade
    }}
>
    <Box sx={{ p: 3 }}>
      <hr style={{ margin: "40px 0", borderTop: "1px solid #ddd" }} />
      <hr style={{ margin: "40px 0", borderTop: "1px solid #ddd" }} />

      <Typography
        variant="h2"
        align="center"
        gutterBottom
        style={{
          fontFamily: "'Lato', serif",
          color: "#800020",
          textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
          borderBottom: "4px solid #d4af37",
          paddingBottom: "10px",
          textTransform: "uppercase",
          animation: "glow 2s infinite alternate",
          marginTop: "7%",
        }}
      >
        Lista de Podcasts
      </Typography>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <List sx={{ backgroundColor: "#f4f6f8", borderRadius: 2, boxShadow: 1 }}>
          {podcasts.map((podcast) => (
            <Paper key={podcast._id} sx={{ marginBottom: 2, padding: 2, borderRadius: 1, boxShadow: 1 }}>
              <ListItem
                secondaryAction={
                  <>
                    <IconButton edge="end" aria-label="edit" onClick={() => handleEditClick(podcast)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton edge="end" aria-label="delete" onClick={() => handleDeletePodcast(podcast._id, podcast.titulo)}>
                      <DeleteIcon />
                    </IconButton>
                  </>
                }
              >
                <ListItemText
  primary={<Typography variant="h6">{podcast.titulo}</Typography>}
  secondary={
    <>
      <Typography variant="body2" color="textSecondary">
        Data de Criação: {new Date(podcast.createdAt).toLocaleDateString()}
      </Typography>
      
    </>
  }
/>

              </ListItem>
              <Divider />
            </Paper>
          ))}
        </List>
      )}

      <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: 3 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/PainelDeControle/DashBoardPodcast")}
          sx={{ padding: "10px 20px", fontSize: "16px" }}
        >
          Adicionar Novo Podcast
        </Button>
      </Box>

      {/* Modal de Edição */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Editar Podcast</DialogTitle>
        <DialogContent>
          <TextField fullWidth label="Título" name="titulo" value={selectedPodcast?.titulo || ""} onChange={handleInputChange} margin="normal" />
          <FormControl fullWidth margin="normal">
            <InputLabel id="serie-edit-podcast-label">Seção do Podcast</InputLabel>
            <Select
              labelId="serie-edit-podcast-label"
              name="serie"
              label="Seção do Podcast"
              value={selectedPodcast?.serie || "trajetorias-pesquisa"}
              onChange={handleInputChange}
            >
              <MenuItem value="trajetorias-pesquisa">
                Sessão 1 - História da Península e Trajetórias de Pesquisa: um podcast sobre o mundo ibérico medieval e moderno
              </MenuItem>
              <MenuItem value="calila-dimna">
                Sessão 2 - Podcast - O papel moral das fábulas na Castela do século XIII: as histórias de Calila e Dimna (Comunicar Ciência)
              </MenuItem>
            </Select>
          </FormControl>
          <TextField fullWidth label="Apresentadores" name="apresentadores" value={selectedPodcast?.apresentadores || ""} onChange={handleInputChange} margin="normal" />
          <TextField fullWidth label="Produção (separado por vírgulas)" name="producao" value={selectedPodcast?.producao || ""} onChange={handleInputChange} margin="normal" />
          <TextField fullWidth label="Fonte" name="fonte" value={selectedPodcast?.fonte || ""} onChange={handleInputChange} margin="normal" />
          <Typography variant="body1" gutterBottom>Descrição:</Typography>
          <ReactQuill value={selectedPodcast?.descricao || ""} onChange={(value) => handleQuillChange("descricao", value)} modules={modules} />
        
          <TextField
  fullWidth
  label="Créditos Detalhados"
  name="creditosDetalhados"
  value={selectedPodcast?.creditosDetalhados || ""}
  onChange={handleInputChange}
  margin="normal"
/>
<MediaUploadField
  label="Arquivo de áudio (episódio)"
  name="linkEpisodio"
  value={selectedPodcast?.linkEpisodio || ""}
  onChange={setSelectedField}
  folder="podcast"
  accept="audio/*,.mp3"
  onError={handleUploadError}
  onSuccess={handleUploadSuccess}
/>
<MediaUploadField
  label="Imagem do episódio"
  name="linkImagem"
  value={selectedPodcast?.linkImagem || ""}
  onChange={setSelectedField}
  folder="podcast"
  accept="image/*"
  onError={handleUploadError}
  onSuccess={handleUploadSuccess}
/>

        
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="secondary">
            Cancelar
          </Button>
          <Button onClick={handleSaveChanges} color="primary">
            Salvar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Alerta Snackbar */}
      <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={() => setOpenSnackbar(false)}>
        <Alert severity={alertMessage.type}>{alertMessage.text}</Alert>
      </Snackbar>
    </Box>
    </div>
  );
};

export default GerenciarPodcasts;
